var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.371,
    height: 15.715,
    viewBox: "0 0 16.371 15.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9218",
    "data-name": "Group 9218",
    transform: "translate(11567 12677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error_Icon",
    "data-name": "Error Icon",
    transform: "translate(-11567 -12677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5248",
    "data-name": "Path 5248",
    d: "M7.731,3.351a2,2,0,0,1,3.538,0l6.183,11.715A2,2,0,0,1,15.683,18H3.317a2,2,0,0,1-1.769-2.934Z",
    transform: "translate(-1.314 -2.285)",
    fill: "#d13949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5247",
    "data-name": "Path 5247",
    d: "M.446,8.584a.528.528,0,0,1-.233-.15A.528.528,0,0,1,.063,8.2.539.539,0,0,1,0,7.922v-.06A.7.7,0,0,1,.1,7.5l.114-.147a.712.712,0,0,1,.321-.186l.192-.026a.528.528,0,0,1,.279.061.546.546,0,0,1,.234.15.555.555,0,0,1,.15.234.543.543,0,0,1,.061.279v.06a.744.744,0,0,1-.1.365l-.114.146a.72.72,0,0,1-.32.187c-.064.007-.129.017-.193.026H.694A.534.534,0,0,1,.446,8.584ZM0,5.645V.725A.736.736,0,0,1,.724,0a.733.733,0,0,1,.725.724v4.92a.737.737,0,0,1-.725.724H.7A.736.736,0,0,1,0,5.645Z",
    transform: "translate(7.459 4.634)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error_triangle.aa6736bd.svg";
export { ForwardRef as ReactComponent };